module.exports = __webpack_public_path__ + "img/nextBlockBg.e2a7c63c.png";